import { render, staticRenderFns } from "./TransferRecordTable.vue?vue&type=template&id=5b4b0275&scoped=true"
import script from "./TransferRecordTable.vue?vue&type=script&lang=js"
export * from "./TransferRecordTable.vue?vue&type=script&lang=js"
import style0 from "./TransferRecordTable.vue?vue&type=style&index=0&id=5b4b0275&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4b0275",
  null
  
)

export default component.exports